import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = [
  '#aa0b56',
  '#0088b0',
  '#5f3dc4',
  '#f59f00',
  '#006d8d',
  '#e67700',
  '#0c8599',
  '#7048e8',
];

const LABELS: Record<string, string> = {
  cash: '現金',
  paypay: 'PayPay',
  airpay_card: 'クレカ(Airペイ)',
  airpay_card_touch: 'クレカ(Airペイ タッチ)',
  airpay_id: 'iD',
  airpay_quicpay: 'QUICPay',
  airpay_qr: 'QR(Airペイ)',
  airpay_qr_v2: 'QR(Airペイ QR)',
  airpay_apple_pay: 'Apple Pay',
  airpay_transit: '交通系IC',
  airpay_unionpay: '銀聯',
  d_payment: 'd払い',
  hpg_smart: 'スマート支払い',
  hpg_point: 'HPGポイント',
  airpay_point: 'Airペイポイント',
  premium_voucher: 'プレミアム商品券',
  square: 'Square',
  recruit_point: 'ポイント',
  credit_other: 'クレジット',
  credit_online: 'クレカ(オンライン)',
  credit_mobile_order: 'クレカ(モバイル)',
  rocket_now: 'Rocket Now',
};

interface Props {
  data: { method: string; amount: number }[];
  height?: number;
}

export const PaymentDonut = ({ data, height = 280 }: Props) => {
  const filtered = data
    .filter((d) => d.amount > 0)
    .map((d) => ({ name: LABELS[d.method] ?? d.method, value: d.amount }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={filtered}
          dataKey="value"
          nameKey="name"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={1}
        >
          {filtered.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(v) => `¥${Number(v).toLocaleString()}`} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
